import { render, staticRenderFns } from "./PolicyBalance.vue?vue&type=template&id=7e8f5208&scoped=true&"
import script from "./PolicyBalance.vue?vue&type=script&lang=ts&"
export * from "./PolicyBalance.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyBalance.vue?vue&type=style&index=0&id=7e8f5208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f5208",
  null
  
)

export default component.exports